import { render, staticRenderFns } from "./Square.vue?vue&type=template&id=03cb1d75&scoped=true&"
import script from "./Square.vue?vue&type=script&lang=js&"
export * from "./Square.vue?vue&type=script&lang=js&"
import style0 from "./Square.vue?vue&type=style&index=0&id=03cb1d75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cb1d75",
  null
  
)

export default component.exports